import corporateConfig from '@/config/corporate';

const UNIT_TYPES = {
    COMPANY: 'company',
    BOARD: 'board',
    SECTOR: 'sector',
    ROLE: 'role',
};

function nowIso() {
    return new Date().toISOString();
}

function createId(prefix = 'id') {
    return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}

function seedData() {
    const companyId = 'company_1';
    const sectorDev = 'unit_sector_dev';
    const sectorInfra = 'unit_sector_infra';
    const sectorFin = 'unit_sector_fin';
    const sectorRh = 'unit_sector_rh';
    const sectorCommercial = 'unit_sector_commercial';
    const roleJr = 'unit_role_dev_jr';
    const rolePl = 'unit_role_dev_pl';
    const roleSr = 'unit_role_dev_sr';
    const roleInfra = 'unit_role_infra';
    const roleAnalyst = 'unit_role_analyst';
    const roleDirector = 'unit_role_director';
    const roleManager = 'unit_role_manager';
    const roleCoordinator = 'unit_role_coordinator';
    const roleIntern = 'unit_role_intern';
    const roleAttendant = 'unit_role_attendant';

    const units = [
        {
            id: 'unit_company_root',
            companyId,
            parentId: null,
            type: UNIT_TYPES.COMPANY,
            name: 'Empresa Demo',
            description: 'Raiz organizacional',
            managerUserId: 'user_mgr_1',
            status: 'active',
            order: 0,
            createdAt: nowIso(),
            updatedAt: nowIso(),
        },
        {
            id: sectorDev,
            companyId,
            parentId: 'unit_company_root',
            type: UNIT_TYPES.SECTOR,
            name: 'Desenvolvimento',
            description: 'Times de engenharia de software',
            managerUserId: 'user_mgr_1',
            status: 'active',
            order: 0,
            createdAt: nowIso(),
            updatedAt: nowIso(),
        },
        {
            id: sectorInfra,
            companyId,
            parentId: 'unit_company_root',
            type: UNIT_TYPES.SECTOR,
            name: 'Infraestrutura',
            description: 'Cloud, redes e operações',
            managerUserId: 'user_mgr_1',
            status: 'active',
            order: 1,
            createdAt: nowIso(),
            updatedAt: nowIso(),
        },
        {
            id: sectorFin,
            companyId,
            parentId: 'unit_company_root',
            type: UNIT_TYPES.SECTOR,
            name: 'Controladoria',
            description: 'Controles financeiros',
            managerUserId: 'user_mgr_2',
            status: 'active',
            order: 2,
            createdAt: nowIso(),
            updatedAt: nowIso(),
        },
        {
            id: sectorRh,
            companyId,
            parentId: 'unit_company_root',
            type: UNIT_TYPES.SECTOR,
            name: 'RH',
            description: 'Recursos humanos e desenvolvimento organizacional',
            managerUserId: 'user_mgr_2',
            status: 'active',
            order: 3,
            createdAt: nowIso(),
            updatedAt: nowIso(),
        },
        {
            id: sectorCommercial,
            companyId,
            parentId: 'unit_company_root',
            type: UNIT_TYPES.SECTOR,
            name: 'Comercial',
            description: 'Vendas e relacionamento com clientes',
            managerUserId: 'user_mgr_2',
            status: 'active',
            order: 4,
            createdAt: nowIso(),
            updatedAt: nowIso(),
        },
        {
            id: roleJr,
            companyId,
            parentId: sectorDev,
            type: UNIT_TYPES.ROLE,
            name: 'Desenvolvedor Júnior',
            description: 'Cargo de entrada em engenharia',
            managerUserId: null,
            status: 'active',
            order: 0,
            courseIds: ['course_mock_1'],
            createdAt: nowIso(),
            updatedAt: nowIso(),
        },
        {
            id: rolePl,
            companyId,
            parentId: sectorDev,
            type: UNIT_TYPES.ROLE,
            name: 'Desenvolvedor Pleno',
            description: 'Engenharia intermediária',
            managerUserId: null,
            status: 'active',
            order: 1,
            courseIds: ['course_mock_1', 'course_mock_2'],
            createdAt: nowIso(),
            updatedAt: nowIso(),
        },
        {
            id: roleSr,
            companyId,
            parentId: sectorDev,
            type: UNIT_TYPES.ROLE,
            name: 'Desenvolvedor Sênior',
            description: 'Engenharia avançada',
            managerUserId: null,
            status: 'active',
            order: 2,
            courseIds: ['course_mock_1', 'course_mock_2'],
            createdAt: nowIso(),
            updatedAt: nowIso(),
        },
        {
            id: roleInfra,
            companyId,
            parentId: sectorInfra,
            type: UNIT_TYPES.ROLE,
            name: 'Analista de Infraestrutura',
            description: 'Operações de infraestrutura',
            managerUserId: null,
            status: 'active',
            order: 0,
            courseIds: ['course_mock_2'],
            createdAt: nowIso(),
            updatedAt: nowIso(),
        },
        {
            id: roleAnalyst,
            companyId,
            parentId: sectorFin,
            type: UNIT_TYPES.ROLE,
            name: 'Analista Financeiro',
            description: 'Análise e reporting financeiro',
            managerUserId: null,
            status: 'active',
            order: 0,
            courseIds: [],
            createdAt: nowIso(),
            updatedAt: nowIso(),
        },
        {
            id: roleDirector,
            companyId,
            parentId: sectorRh,
            type: UNIT_TYPES.ROLE,
            name: 'Diretor',
            description: 'Liderança da área',
            managerUserId: null,
            status: 'active',
            order: 0,
            courseIds: ['course_mock_1'],
            createdAt: nowIso(),
            updatedAt: nowIso(),
        },
        {
            id: roleManager,
            companyId,
            parentId: sectorRh,
            type: UNIT_TYPES.ROLE,
            name: 'Gestor',
            description: 'Gestão de equipes e processos',
            managerUserId: null,
            status: 'active',
            order: 1,
            courseIds: ['course_mock_1', 'course_mock_2'],
            createdAt: nowIso(),
            updatedAt: nowIso(),
        },
        {
            id: roleCoordinator,
            companyId,
            parentId: sectorCommercial,
            type: UNIT_TYPES.ROLE,
            name: 'Coordenador',
            description: 'Coordenação operacional',
            managerUserId: null,
            status: 'active',
            order: 0,
            courseIds: ['course_mock_2'],
            createdAt: nowIso(),
            updatedAt: nowIso(),
        },
        {
            id: roleIntern,
            companyId,
            parentId: sectorCommercial,
            type: UNIT_TYPES.ROLE,
            name: 'Estagiário',
            description: 'Cargo de entrada',
            managerUserId: null,
            status: 'active',
            order: 1,
            courseIds: ['course_mock_1'],
            createdAt: nowIso(),
            updatedAt: nowIso(),
        },
        {
            id: roleAttendant,
            companyId,
            parentId: sectorCommercial,
            type: UNIT_TYPES.ROLE,
            name: 'Atendente',
            description: 'Atendimento ao cliente',
            managerUserId: null,
            status: 'active',
            order: 2,
            courseIds: [],
            createdAt: nowIso(),
            updatedAt: nowIso(),
        },
    ];

    const users = [
        {
            id: 'user_mgr_1',
            companyId,
            name: 'Ana Gestora',
            email: 'ana.gestora@demo.corp',
            corporatePermission: 'gestor',
            boardId: null,
            sectorId: sectorDev,
            roleId: roleSr,
            managerUserId: null,
            isResponsible: true,
            admissionDate: '2020-03-10',
            internalCode: 'COL-001',
            status: 'active',
            progressPercent: 82,
            enrolments: [
                { courseId: 'course_mock_1', courseName: 'Introdução à Empresa', status: 'completed', progress: 100, mandatory: true, source: 'group' },
                { courseId: 'course_mock_intro', courseName: 'Regras e Conduta', status: 'completed', progress: 100, mandatory: true, source: 'group' },
                { courseId: 'course_mock_rules', courseName: 'Melhorias Contínuas', status: 'in_progress', progress: 40, mandatory: true, source: 'group' },
                { courseId: 'course_mock_2', courseName: 'Segurança da Informação', status: 'in_progress', progress: 64, mandatory: true, source: 'sector' },
            ],
            gamificationPoints: 420,
            gamificationLevel: 'Master',
            createdAt: nowIso(),
            updatedAt: nowIso(),
        },
        {
            id: 'user_mgr_2',
            companyId,
            name: 'Bruno Financeiro',
            email: 'bruno.financeiro@demo.corp',
            corporatePermission: 'coordenador',
            boardId: null,
            sectorId: sectorFin,
            roleId: roleAnalyst,
            managerUserId: null,
            isResponsible: true,
            admissionDate: '2019-08-01',
            internalCode: 'COL-002',
            status: 'active',
            progressPercent: 55,
            enrolments: [
                { courseId: 'course_mock_1', courseName: 'Introdução à Empresa', status: 'completed', progress: 100, mandatory: true, source: 'group' },
                { courseId: 'course_mock_intro', courseName: 'Regras e Conduta', status: 'in_progress', progress: 50, mandatory: true, source: 'group' },
            ],
            gamificationPoints: 180,
            gamificationLevel: 'Master',
            createdAt: nowIso(),
            updatedAt: nowIso(),
        },
        {
            id: 'user_col_1',
            companyId,
            name: 'Carla Dev',
            email: 'carla.dev@demo.corp',
            corporatePermission: 'colaborador',
            boardId: null,
            sectorId: sectorDev,
            roleId: rolePl,
            managerUserId: 'user_mgr_1',
            isResponsible: false,
            admissionDate: '2022-01-15',
            internalCode: 'COL-010',
            status: 'active',
            progressPercent: 40,
            enrolments: [
                { courseId: 'course_mock_1', courseName: 'Introdução à Empresa', status: 'completed', progress: 100, mandatory: true, source: 'group' },
                { courseId: 'course_mock_intro', courseName: 'Regras e Conduta', status: 'not_started', progress: 0, mandatory: true, source: 'group' },
                { courseId: 'course_mock_rules', courseName: 'Melhorias Contínuas', status: 'not_started', progress: 0, mandatory: true, source: 'group' },
                { courseId: 'course_mock_2', courseName: 'Segurança da Informação', status: 'not_started', progress: 0, mandatory: true, source: 'role' },
            ],
            gamificationPoints: 90,
            gamificationLevel: 'Iniciante',
            createdAt: nowIso(),
            updatedAt: nowIso(),
        },
        {
            id: 'user_col_2',
            companyId,
            name: 'Diego Junior',
            email: 'diego.junior@demo.corp',
            corporatePermission: 'colaborador',
            boardId: null,
            sectorId: sectorDev,
            roleId: roleJr,
            managerUserId: 'user_mgr_1',
            isResponsible: false,
            admissionDate: '2024-05-20',
            internalCode: 'COL-011',
            status: 'active',
            progressPercent: 15,
            enrolments: [
                { courseId: 'course_mock_1', courseName: 'Introdução à Empresa', status: 'in_progress', progress: 30, mandatory: true, source: 'group' },
                { courseId: 'course_mock_intro', courseName: 'Regras e Conduta', status: 'not_started', progress: 0, mandatory: true, source: 'group' },
                { courseId: 'course_mock_rules', courseName: 'Melhorias Contínuas', status: 'not_started', progress: 0, mandatory: true, source: 'group' },
            ],
            gamificationPoints: 35,
            gamificationLevel: 'Iniciante',
            createdAt: nowIso(),
            updatedAt: nowIso(),
        },
        {
            id: 'user_col_3',
            companyId,
            name: 'Elena Infra',
            email: 'elena.infra@demo.corp',
            corporatePermission: 'colaborador',
            boardId: null,
            sectorId: sectorInfra,
            roleId: roleInfra,
            managerUserId: 'user_mgr_1',
            isResponsible: false,
            admissionDate: '2021-11-02',
            internalCode: 'COL-020',
            status: 'inactive',
            progressPercent: 70,
            enrolments: [
                { courseId: 'course_mock_2', courseName: 'Segurança da Informação', status: 'completed', progress: 100, mandatory: true, source: 'role' },
            ],
            gamificationPoints: 210,
            gamificationLevel: 'Master',
            createdAt: nowIso(),
            updatedAt: nowIso(),
        },
    ];

    const courses = [
        {
            id: 'course_mock_1',
            name: 'Introdução à Empresa',
            comercialName: 'Introdução à Empresa',
            status: 'active',
            shortDescription: 'Conheça a cultura, valores e estrutura da empresa.',
            moduleQty: 3,
            lessonQty: 12,
            imageFinalPath: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&h=500&fit=crop&q=80',
            imageFinalPath2: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&h=500&fit=crop&q=80',
        },
        {
            id: 'course_mock_2',
            name: 'Segurança da Informação',
            comercialName: 'Segurança da Informação',
            status: 'active',
            shortDescription: 'Boas práticas de proteção de dados e acesso.',
            moduleQty: 4,
            lessonQty: 16,
            imageFinalPath: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&h=500&fit=crop&q=80',
            imageFinalPath2: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&h=500&fit=crop&q=80',
        },
        {
            id: 'course_mock_3',
            name: 'LGPD na Prática',
            comercialName: 'LGPD na Prática',
            status: 'active',
            shortDescription: 'Aplicação prática da Lei Geral de Proteção de Dados.',
            moduleQty: 2,
            lessonQty: 8,
            imageFinalPath: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&h=500&fit=crop&q=80',
            imageFinalPath2: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&h=500&fit=crop&q=80',
        },
        {
            id: 'course_mock_intro',
            name: 'Regras e Conduta',
            comercialName: 'Regras e Conduta',
            status: 'active',
            shortDescription: 'Código de conduta e políticas internas.',
            moduleQty: 2,
            lessonQty: 6,
            imageFinalPath: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=800&h=500&fit=crop&q=80',
            imageFinalPath2: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=800&h=500&fit=crop&q=80',
        },
        {
            id: 'course_mock_rules',
            name: 'Melhorias Contínuas',
            comercialName: 'Melhorias Contínuas',
            status: 'active',
            shortDescription: 'Métodos e rotinas para evolução constante do time.',
            moduleQty: 3,
            lessonQty: 10,
            imageFinalPath: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=500&fit=crop&q=80',
            imageFinalPath2: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=500&fit=crop&q=80',
        },
    ];

    const companySettings = {
        companyId,
        isCorporate: true,
        siteEnabled: false,
        tradeName: 'Empresa Demo',
        legalName: 'Empresa Demo LTDA',
        logoUrl: null,
        footer: {
            text: '© Empresa Demo — Educação corporativa interna.',
            links: [
                { label: 'Política de Privacidade', url: '#' },
                { label: 'Código de Conduta', url: '#' },
            ],
            showLogo: true,
        },
        portal: {
            showCertificate: true,
            showInquiry: false,
            showForum: false,
            bannerUrl: null,
        },
        updatedAt: nowIso(),
    };

    const courseGroups = [
        {
            id: 'group_onboarding',
            companyId,
            name: 'Onboarding',
            commercialName: 'Onboarding',
            url: 'onboarding',
            description: 'Trilha inicial: introdução, regras e melhorias.',
            shortDescription: 'Trilha inicial: introdução, regras e melhorias.',
            longDescription: '',
            mode: 'path',
            status: 'active',
            price: 0,
            discount: 0,
            installment: 1,
            approvalEnabled: false,
            minGrade: 0,
            approved: -1,
            certificateEnabled: true,
            certificate: 1,
            availabilityDeadline: 30,
            dayExpired: 30,
            imageUrl: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=500&fit=crop&q=80',
            target: { sectorIds: [], roleIds: [] },
            items: [
                { courseId: 'course_mock_1', order: 1, unlockRule: 'always' },
                { courseId: 'course_mock_intro', order: 2, unlockRule: 'previous_completed' },
                { courseId: 'course_mock_rules', order: 3, unlockRule: 'previous_completed' },
            ],
            createdAt: nowIso(),
            updatedAt: nowIso(),
        },
        {
            id: 'group_security',
            companyId,
            name: 'Segurança',
            commercialName: 'Segurança',
            url: 'seguranca',
            description: 'Treinamentos de segurança e compliance (agrupamento visual).',
            shortDescription: 'Treinamentos de segurança e compliance (agrupamento visual).',
            longDescription: '',
            mode: 'group',
            status: 'active',
            price: 0,
            discount: 0,
            installment: 1,
            approvalEnabled: false,
            minGrade: 0,
            approved: -1,
            certificateEnabled: false,
            certificate: 0,
            availabilityDeadline: 60,
            dayExpired: 60,
            imageUrl: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&h=500&fit=crop&q=80',
            target: { sectorIds: [sectorDev, sectorInfra], roleIds: [] },
            items: [
                { courseId: 'course_mock_2', order: 1, unlockRule: 'always' },
                { courseId: 'course_mock_3', order: 2, unlockRule: 'always' },
            ],
            createdAt: nowIso(),
            updatedAt: nowIso(),
        },
    ];

    return {
        companyId,
        units,
        users,
        courses,
        orgHistory: [],
        companySettings,
        courseGroups,
        courseAssignments: [
            {
                id: 'assign_1',
                companyId,
                resourceType: 'course',
                resourceId: 'course_mock_1',
                courseId: 'course_mock_1',
                sectorId: sectorDev,
                roleId: roleJr,
                userId: null,
                mandatory: true,
                deadlineDays: 30,
                startsAt: null,
                endsAt: null,
                status: 'active',
                createdBy: 'user_mgr_1',
                createdAt: nowIso(),
                updatedAt: nowIso(),
            },
            {
                id: 'assign_group_onboarding',
                companyId,
                resourceType: 'group',
                resourceId: 'group_onboarding',
                courseId: null,
                sectorId: sectorDev,
                roleId: null,
                userId: null,
                mandatory: true,
                deadlineDays: 45,
                startsAt: null,
                endsAt: null,
                status: 'active',
                createdBy: 'user_mgr_1',
                createdAt: nowIso(),
                updatedAt: nowIso(),
            },
            {
                id: 'assign_group_security_dev',
                companyId,
                resourceType: 'group',
                resourceId: 'group_security',
                courseId: null,
                sectorId: sectorDev,
                roleId: null,
                userId: null,
                mandatory: true,
                deadlineDays: 60,
                startsAt: null,
                endsAt: null,
                status: 'active',
                createdBy: 'user_mgr_1',
                createdAt: nowIso(),
                updatedAt: nowIso(),
            },
            {
                id: 'assign_group_security_infra',
                companyId,
                resourceType: 'group',
                resourceId: 'group_security',
                courseId: null,
                sectorId: sectorInfra,
                roleId: null,
                userId: null,
                mandatory: true,
                deadlineDays: 60,
                startsAt: null,
                endsAt: null,
                status: 'active',
                createdBy: 'user_mgr_1',
                createdAt: nowIso(),
                updatedAt: nowIso(),
            },
        ],
    };
}

function isValidState(candidate) {
    return Boolean(
        candidate
        && Array.isArray(candidate.units)
        && Array.isArray(candidate.users)
        && Array.isArray(candidate.courses)
        && Array.isArray(candidate.courseAssignments)
        && Array.isArray(candidate.courseGroups)
        && candidate.companySettings
        && typeof candidate.companySettings === 'object',
    );
}

function loadState() {
    try {
        const raw = localStorage.getItem(corporateConfig.storageKey);
        if (raw) {
            const parsed = JSON.parse(raw);
            if (isValidState(parsed)) {
                return parsed;
            }
            console.warn('[corporate mock] storage inválido, regenerando seed');
        }
    } catch (e) {
        console.warn('[corporate mock] falha ao ler storage', e);
    }
    const seeded = seedData();
    persistState(seeded);
    return seeded;
}

function persistState(state) {
    try {
        localStorage.setItem(corporateConfig.storageKey, JSON.stringify(state));
    } catch (e) {
        console.warn('[corporate mock] falha ao persistir storage', e);
    }
}

let state = loadState();

function getState() {
    return state;
}

function setState(next) {
    state = next;
    persistState(state);
    return state;
}

function mutate(updater) {
    const draft = JSON.parse(JSON.stringify(state));
    const result = updater(draft);
    setState(draft);
    return result;
}

function resetStore() {
    const seeded = seedData();
    setState(seeded);
    return seeded;
}

function normalizeSnapshot(snapshot) {
    if (snapshot && Array.isArray(snapshot.units) && Array.isArray(snapshot.users)) {
        return snapshot;
    }
    return state && Array.isArray(state.units) ? state : seedData();
}

function findUnit(id, snapshot = state) {
    const source = normalizeSnapshot(snapshot);
    return (source.units || []).find((u) => u.id === id) || null;
}

function getDescendantIds(unitId, snapshot = state) {
    const source = normalizeSnapshot(snapshot);
    const ids = [];
    const walk = (parentId) => {
        (source.units || [])
            .filter((u) => u.parentId === parentId)
            .forEach((child) => {
                ids.push(child.id);
                walk(child.id);
            });
    };
    walk(unitId);
    return ids;
}

function getAncestorChain(unitId, snapshot = state) {
    const chain = [];
    let current = findUnit(unitId, snapshot);
    while (current) {
        chain.push(current);
        current = current.parentId ? findUnit(current.parentId, snapshot) : null;
    }
    return chain;
}

function resolveBoardAndSector(unitId, snapshot = state) {
    const chain = getAncestorChain(unitId, snapshot);
    const role = chain.find((u) => u.type === UNIT_TYPES.ROLE) || null;
    const sector = chain.find((u) => u.type === UNIT_TYPES.SECTOR) || null;
    const board = chain.find((u) => u.type === UNIT_TYPES.BOARD) || null;
    return { role, sector, board };
}

function countUsersForUnit(unitId, snapshot = state) {
    const source = normalizeSnapshot(snapshot);
    const unit = findUnit(unitId, source);
    if (!unit) return 0;
    const ids = new Set([unitId, ...getDescendantIds(unitId, source)]);
    return (source.users || []).filter((u) => {
        if (unit.type === UNIT_TYPES.ROLE) return u.roleId === unitId;
        if (unit.type === UNIT_TYPES.SECTOR) return u.sectorId === unitId || ids.has(u.roleId);
        if (unit.type === UNIT_TYPES.BOARD) return u.boardId === unitId || ids.has(u.sectorId) || ids.has(u.roleId);
        return ids.has(u.boardId) || ids.has(u.sectorId) || ids.has(u.roleId);
    }).length;
}

function countCoursesForUnit(unitId, snapshot = state) {
    const source = normalizeSnapshot(snapshot);
    const unit = findUnit(unitId, source);
    if (!unit) return 0;
    const assignments = source.courseAssignments || [];
    if (unit.type === UNIT_TYPES.ROLE) {
        return new Set([
            ...(unit.courseIds || []),
            ...assignments
                .filter((a) => a.roleId === unitId || a.organizationalUnitId === unitId)
                .map((a) => a.resourceType === 'course' ? a.resourceId : a.courseId)
                .filter(Boolean),
        ]).size;
    }
    const descendantIds = getDescendantIds(unitId, source);
    const roles = (source.units || []).filter(
        (u) => u.type === UNIT_TYPES.ROLE && (u.id === unitId || descendantIds.includes(u.id)),
    );
    const courseIds = new Set();
    roles.forEach((r) => (r.courseIds || []).forEach((id) => courseIds.add(id)));
    assignments
        .filter((a) => {
            const targetId = a.roleId || a.sectorId || a.organizationalUnitId;
            return targetId === unitId || descendantIds.includes(targetId);
        })
        .forEach((a) => {
            const id = a.resourceType === 'course' ? a.resourceId : a.courseId;
            if (id) courseIds.add(id);
        });
    return courseIds.size;
}

function enrichUnit(unit, snapshot = state) {
    const source = normalizeSnapshot(snapshot);
    return {
        ...unit,
        usersCount: countUsersForUnit(unit.id, source),
        coursesCount: countCoursesForUnit(unit.id, source),
        managerName: (source.users || []).find((u) => u.id === unit.managerUserId)?.name || null,
    };
}

function buildTree(parentId = null, snapshot = state) {
    const source = normalizeSnapshot(snapshot);
    return (source.units || [])
        .filter((u) => u.parentId === parentId && u.type !== UNIT_TYPES.ROLE)
        .sort((a, b) => a.order - b.order)
        .map((unit) => ({
            ...enrichUnit(unit, source),
            children: [
                ...buildTree(unit.id, source),
                ...(source.units || [])
                    .filter((u) => u.parentId === unit.id && u.type === UNIT_TYPES.ROLE)
                    .sort((a, b) => a.order - b.order)
                    .map((role) => ({ ...enrichUnit(role, source), children: [] })),
            ],
        }));
}

function delay(ms = 180) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

export {
    UNIT_TYPES,
    createId,
    nowIso,
    getState,
    setState,
    mutate,
    resetStore,
    findUnit,
    getDescendantIds,
    getAncestorChain,
    resolveBoardAndSector,
    countUsersForUnit,
    countCoursesForUnit,
    enrichUnit,
    buildTree,
    delay,
};
